import React from 'react';
import PropTypes from 'prop-types';
import MediaCopy from '../modules/content/mediaCopy';
import Collage from '../modules/content/collage';
import PullQuote from '../modules/content/pullQuote';
import CopyCTA from '../modules/cta/copyCta';
import Image from '../modules/content/image';
import Shortcuts from '../modules/cta/shortcuts';
import Video from '../modules/content/video';
import Copy from '../modules/content/copy';
import DonateCTA from '../modules/cta/donateCTA';
import JournalCTA from '../modules/cta/journalCta';
import ImageCTA from '../modules/cta/imageCta';
import Facts from '../modules/content/facts';
import EMail from '../modules/content/email';
import List from '../modules/content/list';
import EntryImageCopy from '../modules/content/entryImageCopy';
import ImageGallery from '../modules/content/imageGallery';

const ArticlePageModules = ({
  content,
  shortcuts,
  showPersonsModule = false,
  showEntryImageCopy = false,
  showImageGallery = false,
  isJournalLanding = false,
}) => (
  <>
    {content.map(
      (module, i) =>
        (showEntryImageCopy && module.__typename === 'SanityEntryImageCopy' && (
          <EntryImageCopy
            key={i}
            imageSrc={module.image.image.asset.fluid}
            alt={module.image.alt}
            copy={module._rawCopy}
          />
        )) ||
        (showImageGallery && module.__typename === 'SanityImageGallery' && (
          <ImageGallery key={i} slides={module.images} />
        )) ||
        (showPersonsModule && module.__typename === 'SanityList' && (
          <List key={i} title={module.title} items={module.listItem} />
        )) ||
        (module.__typename === 'SanityMediaCopy' && (
          <MediaCopy
            key={i}
            type={module.type}
            imageSrc={module.media[0].image?.asset.fluid}
            alt={module.media[0].image?.alt}
            videoSrc={module.media[0].videoFile?.asset.url}
            overline={module.overline}
            copy={module._rawCopy}
          />
        )) ||
        (module.__typename === 'SanityCollage' && (
          <Collage
            key={i}
            type={module.type}
            copy={module._rawCopy}
            bigImageSrc={module.big[0].image?.asset.fluid}
            bigImageAlt={module.big[0].alt}
            bigVideoSrc={module.big[0].videoFile?.asset.url}
            smallImageSrc={module.small[0].image?.asset.fluid}
            smallImageAlt={module.small[0].alt}
            smallVideoSrc={module.small[0].videoFile?.asset.url}
          />
        )) ||
        (module.__typename === 'SanityVideo' && (
          <Video
            key={i}
            videoSrc={module.videoFile.asset.url}
            videoPoster={module.previewImage?.asset.url}
            title={module.title}
            minutes={module.minutes}
            seconds={module.seconds}
            videoModule
          />
        )) ||
        (module.__typename === 'SanityMainImage' && (
          <Image
            key={i}
            imageSrc={module.image.asset.fluid}
            alt={module.image.alt}
          />
        )) ||
        (module.__typename === 'SanityPullQuote' && (
          <PullQuote key={i} quote={module.quote} author={module._rawAuthor} />
        )) ||
        (module.__typename === 'SanityCopy' && (
          <Copy
            key={i}
            copyLeft={module._rawCopyLeft}
            copyRight={module._rawCopyRight}
          />
        )) ||
        (module.__typename === 'SanityFacts' && (
          <Facts
            key={i}
            fact={module.fact}
            slides={module.fact}
            title={module.title}
          />
        )) ||
        (module.__typename === 'SanityMail' && (
          <EMail key={i} title={module.title} />
        )) ||
        (module.__typename === 'SanityDonateCta' && (
          <DonateCTA key={i} ctaText={module.ctaText} />
        )) ||
        (module.__typename === 'SanityJournalCta' && (
          <JournalCTA
            key={i}
            imageSrc={module.journalImage.image.asset.fluid}
            alt={module.journalImage.image.alt}
            overline={module.overline}
            headline={module.headline}
            tags={module.tags?.options}
            copy={module.copy}
            slug={module.slug}
            isJournalLanding={isJournalLanding}
          />
        )) ||
        (module.__typename === 'SanityCopyCta' && (
          <CopyCTA
            key={i}
            overline={module.overline}
            headline={module.headline}
            pageLink={module.link.pageLink}
            ctaText={module.link.ctaText}
          />
        )) ||
        (module.__typename === 'SanityImageCta' && (
          <ImageCTA
            key={i}
            imageSrc={module.image.image.asset.fluid}
            alt={module.image.image.alt}
            overline={module.overline}
            copy={module.copy}
            pageLink={module.link.pageLink}
            ctaText={module.link.ctaText}
          />
        ))
    )}
    {shortcuts && (
      <Shortcuts
        firstImageSrc={shortcuts.firstImage.image.asset.fluid}
        firstImageAlt={shortcuts.firstImage.alt}
        firstPageLink={shortcuts.firstLink.pageLink}
        firstCtaText={shortcuts.firstLink.ctaText}
        secondImageSrc={shortcuts.secondImage.image.asset.fluid}
        secondImageAlt={shortcuts.secondImage.alt}
        secondPageLink={shortcuts.secondLink.pageLink}
        secondCtaText={shortcuts.secondLink.ctaText}
      />
    )}
  </>
);

ArticlePageModules.propTypes = {
  content: PropTypes.array,
  shortcuts: PropTypes.object,
  showPersonsModule: PropTypes.bool,
  showEntryImageCopy: PropTypes.bool,
  showImageGallery: PropTypes.bool,
  isJournalLanding: PropTypes.bool,
};

export default ArticlePageModules;
